import React, { useState } from 'react';
import t from '@guestyci/localize/t.macro';
import { Text, Heading, Stack, Label } from '@guestyci/arc';
import { StepActions } from '../../layout';
import { OtpInput } from '../../../components/InputOTP';
import RememberDeviceCheckbox from '../RememberDeviceCheckbox';

const VerifyCodeStep = ({
  isVerifyMode,
  onVerifyCode,
  onPickDifferentMethod,
  error,
  isSubmitting,
}) => {
  const [code, setCode] = useState('');
  const [rememberDevice, setRememberDevice] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!code) return;
    onVerifyCode(code, rememberDevice);
  };

  const heading = isVerifyMode
    ? t('Google Authenticator')
    : t('Set up Google Authenticator');

  const subtitle = isVerifyMode
    ? t('Enter your Google Authenticator passcode')
    : t('Enter code displayed from the application');

  const secondaryLabel = isVerifyMode
    ? t('Back')
    : t('Pick a different authentication method');

  return (
    <form
      onSubmit={handleSubmit}
      className="gst-flex gst-flex-col gst-flex-1 gst-w-full"
    >
      <Stack spacing={6} className="gst-w-full gst-flex-1">
        <Stack spacing={6}>
          <Stack spacing={4}>
            <Heading variant="h2">{heading}</Heading>
            <Text size="sm">{subtitle}</Text>
          </Stack>

          <Stack spacing={2}>
            <Label htmlFor="totp-code">{t('Enter code')}</Label>
            <OtpInput id="totp-code" value={code} onChange={setCode} />
            {error && (
              <Text size="sm" className="gst-text-destructive">
                {error}
              </Text>
            )}
          </Stack>

          <RememberDeviceCheckbox
            id="google-mfa-remember-device"
            checked={rememberDevice}
            onCheckedChange={setRememberDevice}
            disabled={isSubmitting}
          />
        </Stack>

        <StepActions
          primaryLabel={t('Verify code')}
          primaryType="submit"
          primaryDisabled={!code}
          onSecondaryClick={onPickDifferentMethod}
          secondaryLabel={secondaryLabel}
          isSubmitting={isSubmitting}
        />
      </Stack>
    </form>
  );
};

export default VerifyCodeStep;
